import _groupBy from 'lodash.groupby';
import { LocationSortingTypes } from 'mui/components/sections/DS_FindInMap/models/LocationSortingTypes';

export function flagshipStoreExists(allLocations, sortingAlgorithm = LocationSortingTypes.By_Distance) {
  return (
    !!allLocations.find(location => !!location.flagshipStoreLabel) &&
    sortingAlgorithm !== LocationSortingTypes.By_Distance_And_Timeslots
  );
}

export function orderByFlagStore(allLocations) {
  let newLocations = allLocations;
  const locationsByFlagshipStore = _groupBy(newLocations, location =>
    location.flagshipStoreLabel ? 'flagshipStores' : 'nonFlagshipStores',
  );
  locationsByFlagshipStore.nonFlagshipStores
    ? (newLocations = [
        ...locationsByFlagshipStore.flagshipStores.sort((a, b) => a.slug?.localeCompare(b.slug)),
        ...locationsByFlagshipStore.nonFlagshipStores,
      ])
    : (newLocations = locationsByFlagshipStore.flagshipStores);

  return newLocations;
}
